<div *ngIf="formGroup" [ngClass]="{
	'default': formGroup.pristine,
	'unsaved': !formGroup.pristine || (!formGroup.pristine && !formGroup.valid),
	'error': !entityConfiguration?.entityLoading && form?.submitted && !form?.valid
}">
	
	<div [ngClass]="{'disabled': entityConfiguration?.entityLoading || errorOccured || !deleteRight}" (click)="onDeleteClick()" class="action-button delete-button" *ngIf="entity?.id && !hideDelete">{{ 'DELETE' | translate }}</div>
	<ng-content></ng-content>
	<div (click)="onUndoClick()" class="action-button position-start" *ngIf="entityConfiguration?.reduxConfig">
		{{ 'UNDO' | translate }}
	</div>
	<div (click)="onRedoClick()" class="action-button position-start" *ngIf="entityConfiguration?.reduxConfig">
		{{ 'REDO' | translate }}
	</div>
	<div class="more-buttons">
		<div class="action-button cancel-button" data-cy="action-bar-cancel-button" [ngClass]="{'disabled': entity?.id && (entityConfiguration?.entityLoading || errorOccured || formGroup.pristine) }" (click)="onCancelClick()">{{ 'CANCEL' | translate }}</div>
		<div class="action-button save-button" [ngClass]="{'disabled': entityConfiguration?.entityLoading || errorOccured || (!putRight && !overrideAllowSave) || saveDisabled }">
			<div [title]="saveDisabled ? (rootRights ? 'This is an old converted timeline. Shift-Alt-click to force saving this converted old timeline. (root only)' : 'This feature is still in testdrive, so saving old timelines is disabled for now.') : ''"
				[style.pointer-events]="saveDisabled ? 'all' : 'inherit'"
				(click)="(rootRights && $event.altKey && $event.shiftKey) || !saveDisabled ? onSaveClick() : void"
			>
				{{ (entityConfiguration?.defaultVersionState ? 'SAVE_DRAFT' : 'SAVE') | translate }}
			</div>
		</div>
		<div *ngIf="modalRouteService.modalOpen && inModal" class="action-button close-button" (click)="modalRouteService.close()">
			{{ 'CLOSE' | translate }}
		</div>
		<a *ngIf="previewLink" class="action-button preview-button" (click)="onPreviewClick(previewLink, $event)" [href]="previewLink" target="_blank">{{ 'PREVIEW' | translate }}</a>
		<!-- <div *ngIf="entityConfiguration?.defaultVersionState" class="action-button publish-button" [ngClass]="{'disabled': entityConfiguration?.entityLoading || errorOccured || !putRight }" (click)="onPublishClick()">{{ 'PUBLISH' | translate }}</div> -->
		<!-- Temp disabled publish: -->
		<div
			*ngIf="entityConfiguration?.defaultVersionState"
			class="action-button publish-button"
			[class.disabled]="saveDisabled || (entityConfiguration?.versionIsPublished && formGroup.pristine)"
		>
			<div [title]="saveDisabled ? (rootRights ? 'This is an old converted timeline. Shift-Alt-click to force publishing this converted old timeline. (root only)' : 'This feature is still in testdrive, so publishing old timelines is disabled for now.') : ''"
				[style.pointer-events]="saveDisabled && !(entityConfiguration?.versionIsPublished && formGroup.pristine) ? 'all' : 'inherit'"
				(click)="(rootRights && $event.altKey && $event.shiftKey) || !saveDisabled ? onPublishClick() : void"
			>
				{{ (!(entityConfiguration?.versionIsPublished && formGroup.pristine) ? 'PUBLISH' : 'PUBLISHED') | translate }}
			</div>
		</div>
		<!-- <div *ngIf="entityConfiguration?.defaultWorkingState" class="action-button" (click)="showPublish = !showPublish">
			<i class="fa fa-angle-up" *ngIf="!showPublish"></i>
			<i class="fa fa-angle-down" *ngIf="showPublish"></i>
		</div> -->
		<ng-content select=".position-end"></ng-content>
	</div>
</div>
